import { Flex, Typography, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import { CustomButton } from "ui";
import styles from "./whitelist.module.css";
import { ReactComponent as DotIcon } from "images/Steps/dot.svg";
import { ReactComponent as InfoIcon } from "images/info-icon.svg";
import { useStores } from "stores";
import { requestWithNotify } from "utils";
import { useState } from "react";
import { ConfirmationModal } from "components/ActionModals/ConfirmationModal";
import { updateWhitelist } from "services";
import { useNotificationContext } from "providers";

export const WhitelistActionBtn = observer(() => {
  const { actionModals, settings, user } = useStores();
  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);
  const { whitelistEnabled: whitelistOn } = settings.companySettings;

  const successText = !whitelistOn ? `Белый список включен` : `Белый список выключен`;

  const dotIconClass = whitelistOn ? styles.listOn : styles.listOff;

  const buttonText = whitelistOn ? "Выключить" : "Включить";
  const statusText = whitelistOn ? "Включен" : "Выключен";

  const modalTitle = !whitelistOn ? "Включение белого списка" : "Выключение белого списка";
  const modalText = !whitelistOn
    ? "Вы уверены, что хотите включить белый список адресов?"
    : "Вы уверены, что хотите выключить белый список адресов?";

  const updateWhitelistHandler = async () => {
    try {
      setLoading(true);
      await requestWithNotify({
        fetchFn: () => updateWhitelist(user.userInfo?.company_id || "", { whitelistEnabled: !whitelistOn }),
        openNotification,
      });
    } finally {
      setLoading(false);
    }
  };

  const openModalHandler = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          calledQuery={() => updateWhitelistHandler()}
          text={modalText}
          successText={successText}
          buttonText="Подтвердить"
          cancelButtonText="Отмена"
          fullWidth={true}
          onSuccess={() => {
            requestWithNotify({
              fetchFn: () => settings.fetchCompanySettings(user.userInfo?.company_id || ""),
              openNotification,
              delay: 1500,
              showErrorNotification: false,
            });
          }}
        />
      ),
      { title: modalTitle, width: "550px", onClose: () => actionModals.closeAll() }
    );
  };

  return (
    <Flex gap="small" align="center" className={styles.listWrapper}>
      <Flex>
        <Flex align="center" gap="small">
          <DotIcon className={dotIconClass} />
          <Typography.Text>{statusText}</Typography.Text>
        </Flex>
        <Tooltip title="При создании котировки в качестве адреса получателя будет возможно использовать только адреса из списка">
          <InfoIcon style={{ width: 16, height: 16, marginBottom: "16px" }} />
        </Tooltip>
      </Flex>
      <CustomButton size="small" variant="outlined" onClick={openModalHandler} disabled={loading} loading={loading}>
        {buttonText}
      </CustomButton>
    </Flex>
  );
});
